export const projectsData = [
  {
    id: 'ifp-75-sitash',
    title: 'Sitash Interactive Flat Panel 75"',
    category: 'Interactive Flat Panels',
    description: 'Professional 75-inch interactive flat panel with 4K UHD resolution, multi-touch technology, and mobile stand. Perfect for collaborative learning.',
    longDescription: 'The Sitash 75-inch Interactive Flat Panel transforms traditional classrooms into dynamic, collaborative learning environments. Featuring stunning 4K UHD resolution, responsive multi-touch technology, and an intuitive interface, this panel enables teachers and students to interact naturally with educational content. The included mobile stand with wheels provides flexibility to move the panel between rooms. Built-in pen tray keeps markers organized, while the robust mounting system ensures stability during use.',
    image: '/products/panel-sitash-full.jpg',
    images: [
      '/products/panel-sitash-full.jpg',
      '/products/panel-sitash-collage.jpg',
      '/products/panel-sitash-branding.jpg'
    ],
    year: '2024',
    client: 'Sitash Education Series',
    services: ['Interactive Display', 'Multi-Touch', 'Mobile Stand'],
    results: [
      '75-inch Large Display Area',
      '4K UHD Resolution (3840×2160)',
      '20/40 Point Multi-Touch',
      'Mobile Stand with Locking Wheels',
      'Integrated Pen Tray',
      'Android & Windows Compatible',
      'OPS Slot for PC Module',
      'Anti-Glare Tempered Glass'
    ],
    technologies: ['Android OS', 'Windows Compatible', 'HDMI/USB-C', 'OPS Standard'],
    specifications: {
      screenSize: '75 inches (190.5 cm diagonal)',
      resolution: '4K UHD (3840×2160)',
      aspectRatio: '16:9',
      brightness: '450 cd/m²',
      contrast: '4000:1',
      viewingAngle: '178° (H) / 178° (V)',
      responseTime: '8ms',
      touchTechnology: 'Infrared 20/40 Point Multi-Touch',
      displayType: 'LED Backlit LCD',
      glassType: 'Anti-Glare Tempered Glass',
      os: 'Android 11 / Windows Compatible',
      ram: '4GB DDR4',
      storage: '32GB',
      connectivity: 'HDMI×3, VGA, USB×4, Type-C, LAN, WiFi',
      audio: 'Built-in 2×15W Stereo Speakers',
      opsSlot: 'Standard 80-pin OPS Slot',
      mounting: 'VESA 600×400mm',
      stand: 'Heavy-Duty Mobile Stand with Wheels',
      penTray: 'Integrated Aluminum Pen Tray',
      power: 'AC 100-240V, 50/60Hz',
      dimensions: '1695×1014×90mm (W×H×D)',
      weight: 'Approx. 42kg (panel only)'
    }
  },
  {
    id: 'ifp-65-edla',
    title: 'Interactive Panel 65" EDLA',
    category: 'Interactive Flat Panels',
    description: 'Google EDLA certified 65-inch panel with AI features, gesture controls, and advanced annotation tools.',
    longDescription: 'Premium 65-inch panel featuring Android 14 with Google EDLA certification. Includes artificial intelligence capabilities, gesture controls, security locks, and fully functional Type-C ports. Advanced features include speech-to-text, quick start interface, QR code sharing, embedded annotation software, and lecture recording with broadcasting capabilities.',
    image: 'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=800',
    year: '2024',
    client: 'Premium Education Series',
    services: ['Google Certified', 'AI Features', 'Advanced Tools'],
    results: [
      'Google EDLA Certified',
      'Android 14 Operating System',
      'AI & Gesture Controls',
      'Lecture Recording & Broadcasting'
    ],
    technologies: ['Android 14', 'Google EDLA', 'AI Integration', 'Type-C Ports']
  },
  {
    id: 'ifp-75-standard',
    title: 'Interactive Panel 75"',
    category: 'Interactive Flat Panels',
    description: '75-inch large format display ideal for bigger classrooms and lecture halls.',
    longDescription: 'Large 75-inch display providing expansive viewing area for medium to large classrooms. Features 4K UHD resolution, OPS compliance, and 20/40 multi-touch technology. Perfect for collaborative learning environments with wireless screen sharing and video conferencing capabilities.',
    image: 'https://images.unsplash.com/photo-1593359863503-f598dbc00c18?w=800',
    year: '2024',
    client: 'Education Series',
    services: ['Large Format Display', 'Multi-Touch', 'Collaboration'],
    results: [
      '75-inch Large Display',
      '4K UHD Resolution',
      'Wireless Collaboration',
      'Video Conferencing Ready'
    ],
    technologies: ['Android OS', 'Windows Compatible', 'OPS Standard', 'Wireless Cast']
  },
  {
    id: 'ifp-86-edla',
    title: 'Interactive Panel 86" EDLA',
    category: 'Interactive Flat Panels',
    description: 'Extra-large 86-inch Google certified panel with premium features for large lecture halls.',
    longDescription: 'Premium 86-inch interactive panel with Google EDLA certification and Android 14. Features include artificial intelligence, gesture controls, 4K UHD resolution, Type-C connectivity, speech-to-text, and advanced whiteboard features. Ideal for universities and large training centers.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800',
    year: '2024',
    client: 'Premium Education Series',
    services: ['Extra Large Display', 'Google Certified', 'Advanced AI'],
    results: [
      '86-inch Extra Large Screen',
      'Google EDLA Certified',
      'Advanced Whiteboard Features',
      'Wireless Tablet Collaboration'
    ],
    technologies: ['Android 14', 'Google EDLA', 'AI Features', 'Multi-Device Cast']
  },
  {
    id: 'spx48-camera',
    title: 'Sitash SPX48 4K 20X PTZ Camera',
    category: 'Education Cameras',
    description: 'Professional 4K PTZ camera with 20X optical zoom, Sony CMOS sensor, and intelligent tracking. Perfect for lecture capture and video conferencing.',
    longDescription: 'The Sitash SPX48 is a premium 4K PTZ camera designed specifically for educational and professional environments. Featuring a Sony 1/2.8\" HD CMOS sensor with 8.29 effective megapixels, this camera delivers exceptional image quality with vivid colors and high resolution. The 20X optical zoom (f=5.33mm~92.60mm) provides flexible framing options, while the advanced ISP processing ensures fantastic color rendition even in challenging lighting conditions.',
    image: '/products/camera-spx48-front.jpg',
    images: [
      '/products/camera-spx48-front.jpg',
      '/products/camera-spx48-angle1.jpg',
      '/products/camera-spx48-angle2.jpg',
      '/products/camera-spx48-top.jpg'
    ],
    year: '2024',
    client: 'Professional Camera Series',
    services: ['4K Recording', 'PTZ Control', 'Live Streaming'],
    results: [
      '4K Ultra HD @ 30fps (3840×2160)',
      '20X Optical Zoom',
      'Sony 1/2.8\" CMOS Sensor (8.29MP)',
      'Intelligent Auto-Tracking',
      '±168° Pan, -30°~+90° Tilt',
      'Up to 255 Preset Positions'
    ],
    technologies: ['USB 3.0', 'HDMI 1.4', 'RS232/RS485', 'VISCA/Pelco Protocol'],
    specifications: {
      sensor: 'Sony 1/2.8\" HD Color CMOS',
      resolution: '8.29 Megapixels',
      zoom: '20X Optical Zoom',
      lens: 'f=5.33mm~92.60mm, F1.55~F3.13',
      fov: 'H: 55.8°(W)~3.2°(T), V: 32.2°(W)~1.8°(T)',
      pan: '±168°',
      tilt: '-30°~+90°',
      speed: '1°~60°/s',
      presets: 'Up to 255 positions',
      minLux: '0.5 Lux @ F1.8',
      snr: '≥50dB',
      outputs: 'HDMI 4K30, USB 3.0',
      protocols: 'VISCA, Pelco-D, Pelco-P',
      power: 'DC 12V, Max 10W',
      weight: '1.2kg',
      dimensions: '180×180×175mm',
      tracking: 'Intelligent Auto-Tracking, Auto Frame',
      os: 'Windows 7+, MacOS, Linux, Android'
    }
  },
  {
    id: 'smart-classroom-package',
    title: 'Complete Smart Classroom',
    category: 'Smart Classroom Solutions',
    description: 'All-in-one package: Interactive panel, camera system, and collaboration software.',
    longDescription: 'Turnkey smart classroom solution combining our premium 75-inch interactive panel, 4K education camera, wireless collaboration tools, and comprehensive training. Includes installation, configuration, and ongoing support for seamless digital learning transformation.',
    image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800',
    year: '2024',
    client: 'Complete Solutions',
    services: ['Full Installation', 'Training', 'Support'],
    results: [
      '50+ Classrooms Deployed',
      '95% Teacher Satisfaction',
      'Enhanced Student Engagement',
      'Seamless Hybrid Learning'
    ],
    technologies: ['Interactive Panel', '4K Camera', 'Collaboration Software', 'Cloud Integration']
  }
];